import { camelCase, findIndex, isEmpty } from "lodash/fp";

import type {
  OnboardingSource,
  RouteStepId,
  StepId,
  StepState,
} from "@app/analytics/onboarding/types";

const ONBOARDING_SOURCES: OnboardingSource[] = ["default", "rss", "meet"];

const isOnboardingSource = (
  source?: string | null
): source is OnboardingSource =>
  !isEmpty(source) && ONBOARDING_SOURCES.includes(source as OnboardingSource);

export const getOnboardingSource = (
  source?: string | null
): OnboardingSource => (isOnboardingSource(source) ? source : "default");

export const getStepIndex = (steps: StepState[], stepId: StepState["id"]) =>
  findIndex({ id: stepId }, steps);

export const getStepIdFromRouteStepId = (routeStepId: RouteStepId | null) =>
  routeStepId ? (camelCase(routeStepId) as StepId) : null;
